<template>
  <div id="app" :class="{isDownload: submitPass, app: true}">
    <header>
      <img src="./assets/img/logo.png" alt="">
    </header>
    <div class="content">
      <template v-if="!submitPass">
        <!-- <div class="item">
          <img src="./assets/img/icon1.png" alt="" >
          <input type="text" placeholder="Enter UserName" v-model="userName">
        </div> -->
		  <div class="item mb5">
		    <img src="./assets/img/icon3.png" alt="">
		      &nbsp; +91
		    <input type="number" placeholder="Enter phone number" v-model="phoneNo" maxlength="10" :disabled="!!count" :class="!!count ? 'disabled' : ''"/>
		  </div>
      <p class="tip">Please enter 10 digit phone number</p>
      
      <div class="item mb5">
        <img src="./assets/img/icon6.png" alt="">
        <input type="text" placeholder="Enter Password" v-model="passwd" >
      </div>
      <p class="tip">Please enter 6 - 20 characters</p>
      
      <div class="item imageCode">
        <img class="row-icon" src="./assets/img/icon1.png" alt="">
        <input type="text" inputmode="text" autocomplete="off" placeholder="Enter image code" v-model="captcha">
        <div class="captcha-side">
          <img v-if="captchaImageUrl" class="captcha-img" :src="captchaImageUrl" alt="captcha" @click="loadCaptcha">
          <span @click="loadCaptcha" class="captcha-refresh">Refresh</span>
        </div>
      </div>

      <div class="item optCode">
		    <img src="./assets/img/icon3.png" alt="">
		    <input type="number" placeholder="Enter otp code" v-model="smsOtp">
        <span @click="getCode" :class="!!count ? 'disabled' : ''">
          {{ count === null ? 'Send' : `${count} s` }}
        </span>
		  </div>
        <div class="item">
          <img src="./assets/img/icon1.png" alt="">
          <input type="text" placeholder="Enter invite code" v-model="inviteCode">
        </div>
        <div class="item" @click="submitData">Register</div>
        
      </template>
      <div v-else class="item">
        <a :href="h5Url">Download</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast ,Dialog,Loading  } from 'vant-green';
import { registerUser, sendVerCodeV2, getCaptcha } from "./assets/api/common"

export default {
  name: 'App',
  components: {},
  data () {
    return {
      submitPass: false,
      userName:null,
      phoneNo:null,
      passwd:null,
      optCode: null,
      inviteCode:null,
      smsOtp:null,
      captcha: '',
      captchaToken: null,
      captchaImageUrl: '',
      h5Url:null,
      count: null,
      timer: null
    }
  },
  mounted() {
    this.loadCaptcha();
	  
    const params = Object.create(null);
    let { href } = location;
    href.slice(href.indexOf('?') + 1).split('&').map(t => {
      let [k, v] = t.split('=');
      params[k] = v;
    });
	  
    this.orderUrl = location.href;
    console.info(this.orderUrl);
    var inviteCode1 = params["inviteCode"];
    this.$nextTick(_ => {
      this.inviteCode=inviteCode1;
    })
  },
  beforeDestroy () {
    if (this.captchaImageUrl) {
      URL.revokeObjectURL(this.captchaImageUrl)
    }
  },


 methods:{
  loadCaptcha () {
    if (this.captchaImageUrl) {
      URL.revokeObjectURL(this.captchaImageUrl)
      this.captchaImageUrl = ''
    }
    this.captcha = ''
    getCaptcha().then((res) => {
      this.captchaToken = res.captchaToken
      this.captchaImageUrl = URL.createObjectURL(res.blob)
    }).catch(() => {
      alert('Failed to load captcha, please tap Refresh')
    })
  },

  getCode () {
    if(!this.phoneNo){
      alert("Please enter your phone number");
      return;
    }
    if(!this.passwd){
      alert("Please enter your passwd");
      return;
    }
    if(!this.inviteCode){
      alert("Please enter your inviteCode");
      return;
    }
    if(!this.captcha || !String(this.captcha).trim()){
      alert("Please enter image code");
      return;
    }
    if(!this.captchaToken){
      alert("Captcha expired, please refresh image code");
      this.loadCaptcha();
      return;
    }
    if (!this.timer && this.count === null) {
      sendVerCodeV2(this.userName,this.phoneNo,this.passwd,this.inviteCode,this.captcha.trim(),this.captchaToken,'').then(res => {
            if ('000000' === res.code) {
                this.count = 60;
                this.timer = setInterval(() => {
                this.count -= 1;
                if (this.count == 0) {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.count = null;
                }
                }, 1000);
            }else{
              alert(res.msg);
              this.loadCaptcha();
            }
    })
    }
  },
  submitData(){

    if(!this.phoneNo){
      alert("Please enter your phone number");
      return;
    }
    if(!this.passwd){
      alert("Please enter your passwd");
      return;
    }
    if(!this.inviteCode){
      alert("Please enter your inviteCode");
      return;
    }
    if(!this.smsOtp){
      alert("Please enter your smsOtp");
      return;
    }
    if(!this.captcha || !String(this.captcha).trim()){
      alert("Please enter image code");
      return;
    }
    if(!this.captchaToken){
      alert("Captcha expired, please refresh image code");
      this.loadCaptcha();
      return;
    }


    registerUser(this.userName,this.phoneNo,this.passwd,this.inviteCode,this.smsOtp,this.captcha.trim(),this.captchaToken,'').then(res => {
            if ('000000' === res.code && res.data) {
              this.h5Url=res.data.h5DownloadUrl;
              this.submitPass=true;
            }else{
              alert(res.msg);
              this.loadCaptcha();
            }
    })
  }


 }


}


</script>

<style scope lang="scss">
.app {
  width: 100%;
  height: 100%;
  padding-top: 47px;
  box-sizing: border-box;
  /* background: linear-gradient(180deg, #6a68ff 0%, #30c8f6 100%); */
  background: url('./assets/img/bg.png') no-repeat;
  background-size: 100% 100%;
  header{
    text-align: center;
    margin: 20px 0;
    img{
      width: 127px;
    }
  }
  .content{
    max-width: 500px;
    margin: 40px auto;
    .item{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 5%;
      width: 90%;
      box-sizing: border-box;
      background: #fff;
      border-radius: 30px;
      height: 46px;
      margin-bottom: 17px;
      font-size: 14px;
      position: relative;
      overflow: hidden;
      
      img{
        width: 26px;
        margin-left: 15px;
      }
      input{
        flex: 1;
        border-left: 1px solid #e5e5e5;
        margin-left: 10px;
        padding: 3px 15px 3px 12px;
        font-size: 14px;
        &::-webkit-input-placeholder{
          font-size: 14px;
        }
      }
      a{
        flex: 1;
        color: #fff;
        text-align: center;
      }
      span{
        background: #6950FB;
        color: #fff;
        position:sticky;
        right: 0;
        top: 0;
        width: 70px;
        line-height: 46px;
        text-align: center;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        height: 46px;
        cursor: pointer;
      }
      &:first-child{
        input{
          border-left: none;
          margin-left: 5px;
          padding-left: 5px;
        }
      }
      &:last-child{
        justify-content: center;
        background: #6950FB;
        cursor: pointer;
        color: #fff;
        font-size: 16px;
      }
      .disabled{
        cursor: not-allowed;
      }
    }
    .mb5{
      margin-bottom: 5px;
    }
    .tip {
      margin-left: 15%;
      margin-bottom: 15px;
      color: #FFFFFF;
    }
    .imageCode {
      .row-icon {
        flex-shrink: 0;
        width: 26px;
        height: 26px;
        object-fit: contain;
      }
      input {
        min-width: 0;
      }
      .captcha-side {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        height: 100%;
        background: #f5f5f5;
        border-left: 1px solid #e5e5e5;
      }
      .captcha-img {
        width: auto;
        min-width: 88px;
        max-width: 120px;
        height: 40px;
        margin: 0 0 0 4px;
        object-fit: contain;
        cursor: pointer;
        user-select: none;
      }
      .captcha-refresh {
        position: static;
        width: 72px;
        flex-shrink: 0;
        line-height: 46px;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        border-radius: 0;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
      }
    }
    .optCode{
      span{
        background-color: #6950FB;
        color: #fff;
        font-weight: 700;
        width: 100px;
        flex-shrink: 0;
        cursor: pointer;
        user-select: none;
      }
      .disabled{
        background-color: #6a50fbd2;
        cursor: not-allowed;
      }
    }
  }
}
</style>
